<div class="ri-wrapper">

  <!-- ── Header: title + toggles ──────────────────────────── -->
  <div class="ri-header">
    <span class="ri-title"> {{ sectionTitle }} ({{ recordCount }})</span>

    <div class="ri-controls">

      <!-- Impact toggle group -->
      <div class="ri-control-group">
        <span class="ri-control-label">Impact</span>
        <div class="ri-toggle-group">
          <button class="ri-toggle-btn" [class.active]="impact === 'h'" (click)="setImpact('h')">High</button>
          <button class="ri-toggle-btn" [class.active]="impact === 'm'" (click)="setImpact('m')">Medium</button>
          <button class="ri-toggle-btn" [class.active]="impact === 'l'" (click)="setImpact('l')">Low</button>
        </div>
      </div>

      <!-- Likelihood toggle group -->
      <div class="ri-control-group">
        <span class="ri-control-label">Likelihood</span>
        <div class="ri-toggle-group">
          <button class="ri-toggle-btn" [class.active]="likelihood === 'h'" (click)="setLikelihood('h')">High</button>
          <button class="ri-toggle-btn" [class.active]="likelihood === 'm'" (click)="setLikelihood('m')">Medium</button>
          <button class="ri-toggle-btn" [class.active]="likelihood === 'l'" (click)="setLikelihood('l')">Low</button>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Table section ──────────────────────────────────────── -->
  <div class="ri-table-section">

    <!-- Lavender sub-header -->
    <!-- <div class="ri-section-header">
      {{ sectionTitle }} ({{ recordCount }})
    </div> -->

    <!-- Table / no-data -->
    <div class="ri-table-body">
      <ng-container *ngIf="tableRows.length > 0; else noDataTpl">
        <app-zorro-table
          [columns]="tableColumns"
          [data]="tableRows"
          [options]="tableOptions">
        </app-zorro-table>
      </ng-container>
      <ng-template #noDataTpl>
        <app-no-data></app-no-data>
      </ng-template>
    </div>

  </div>

</div>
